import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { Settings, APP_CONFIG } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { OrientationsGridItem } from 'src/app/travelxnew/models/orientations-grid-item.model';
import { OrientationContract } from 'src/app/travelxnew/models/orientation-profile/orientation-contract.model';
import { OrientationOverview } from 'src/app/travelxnew/models/orientation-profile/orientation-overview.model';
import { OrientationCompliance } from 'src/app/travelxnew/models/orientation-profile/orientation-compliance.model';
import { OrientationPayroll } from 'src/app/travelxnew/models/orientation-profile/orientation-payroll.model';
import { OrientationHousing } from 'src/app/travelxnew/models/orientation-profile/orientation-housing.model';
import { OrientationBenefit } from 'src/app/travelxnew/models/orientation-profile/orientation-benefit.model';
import { OrientationFacility } from 'src/app/travelxnew/models/orientation-profile/orientation-facility.model';

@Injectable({
    providedIn: 'root'
})
export class OrientationsService {
    private readonly coreApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getOrientations(args: FetchArgs): Observable<PagingTokenFixed<OrientationsGridItem[]>> {
        return this.http.post<PagingTokenFixed<OrientationsGridItem[]>>(
            `${this.coreApiPath}/travelx/orientations`,
            args
        );
    }

    getOrientationContractsByCandidateId(candidateId: number) {
        return this.http.get<OrientationContract[]>(
            `${this.coreApiPath}/travelx/orientations/${candidateId}/contracts`
        );
    }

    updateOrientationStatus(contractId: number, orientationStatusId: number) {
        return this.http.put(
            `${this.coreApiPath}/travelx/orientations/${contractId}/status/${orientationStatusId}`,
            null
        );
    }

    getOrientationOverview(contractId: number): Observable<OrientationOverview> {
        return this.http.get<OrientationOverview>(`${this.coreApiPath}/travelx/orientations/${contractId}/overview`);
    }

    getOrientationCompliance(contractId: number): Observable<OrientationCompliance> {
        return this.http.get<OrientationCompliance>(
            `${this.coreApiPath}/travelx/orientations/${contractId}/compliance`
        );
    }

    getOrientationPayroll(contractId: number): Observable<OrientationPayroll> {
        return this.http.get<OrientationPayroll>(`${this.coreApiPath}/travelx/orientations/${contractId}/payroll`);
    }

    getOrientationHousing(contractId: number): Observable<OrientationHousing> {
        return this.http.get<OrientationHousing>(`${this.coreApiPath}/travelx/orientations/${contractId}/housing`);
    }

    getOrientationBenefits(contractId: number): Observable<OrientationBenefit> {
        return this.http.get<OrientationBenefit>(`${this.coreApiPath}/travelx/orientations/${contractId}/benefits`);
    }

    getOrientationFacility(contractId: number): Observable<OrientationFacility> {
        return this.http.get<OrientationFacility>(`${this.coreApiPath}/travelx/orientations/${contractId}/facility`);
    }
}
